import { useEffect, useState } from 'react';
import { pure } from 'recompose';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { enableAmplitudeTracking, initialiseAmplitudeData } from '../../analytics/amplitudeService';
import getClientConfig from '../../utils/getClientConfig';
import {
    addCookieBannerPageOverlay,
    describeCookieBannerRequirement,
    describeCookieBannerChoiceState,
    cookieGroupAllowed,
} from './oneTrustUtils';
import { getCurrentUserId, getCurrentUserOTToken, isGuestSelector } from '../../user/currentUserSelector';
import useOneTrustLoader from './useOneTrustLoader';
import { COOKIE_GROUPS, ONE_TRUST_STATE } from './oneTrustConstants';

const mapStateToProps = createStructuredSelector({
    isGuest: isGuestSelector,
    userId: getCurrentUserId,
    userOTToken: getCurrentUserOTToken,
});

const OneTrustInit = pure(({ isGuest, userId, userOTToken }) => {
    const config = getClientConfig();

    const [oneTrustState] = useOneTrustLoader({ isGuest, userId, userOTToken });
    const [performanceCookiesAllowed, setPerformanceCookiesAllowed] = useState(() =>
        cookieGroupAllowed(COOKIE_GROUPS.PERFORMANCE_COOKIES),
    );

    // On an initial load of the component, initialise OneTrust display and some function hooks
    useEffect(() => {
        if (oneTrustState === ONE_TRUST_STATE.INITIALISED) {
            // Add additional element and information to HTML DOM
            addCookieBannerPageOverlay();
            describeCookieBannerRequirement();
            describeCookieBannerChoiceState();

            setPerformanceCookiesAllowed(cookieGroupAllowed(COOKIE_GROUPS.PERFORMANCE_COOKIES));

            // eslint-disable-next-line new-cap
            window.OneTrust.OnConsentChanged(() => {
                setPerformanceCookiesAllowed(cookieGroupAllowed(COOKIE_GROUPS.PERFORMANCE_COOKIES));

                describeCookieBannerChoiceState();
            });
        }
    }, [oneTrustState]);

    // When performanceCookiesAllowed value change, determine whether or not to enable/disable analytics
    useEffect(() => {
        if (performanceCookiesAllowed === null) return;

        enableAmplitudeTracking(performanceCookiesAllowed);

        if (performanceCookiesAllowed) {
            initialiseAmplitudeData(config);
        }
    }, [performanceCookiesAllowed]);

    return null;
});

export default connect(mapStateToProps)(OneTrustInit);
